module.exports = __webpack_public_path__ + "img/useb_black_logo.4e01de33.svg";